/**
 * Narrow an untrusted object before reading driver- or SDK-specific fields.
 *
 * External errors and transport results are structurally open: their useful
 * metadata often lives on properties such as `cause`, `code`, or `rows`, but
 * those values enter the application as `unknown`. Keeping this guard in the
 * shared boundary vocabulary avoids repeating implementation-site casts.
 */
export function isUnknownRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

/** Narrow an untrusted collection without allowing its elements to become `any`. */
export function isUnknownArray(value: unknown): value is unknown[] {
  return Array.isArray(value);
}
